import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { PageHeader } from "../components/common";
import { UserAvatar, roleLabel } from "../components/UserAvatar";
import { PhotoBox, PersonalForm, EmailForm } from "../components/ProfileForms";
import { ProfileSecurity } from "../components/ProfileSecurity";
import { MyCompany } from "../components/MyCompany";

function Header({ user, t }) {
  return (
    <div className="card p-4 flex items-center gap-4 mb-4" data-testid="profile-header">
      <UserAvatar user={user} size="w-16 h-16 text-xl" testid="profile-header-avatar" />
      <div className="min-w-0">
        <div className="text-xl font-extrabold truncate" data-testid="profile-header-name">{user.name}</div>
        <div className="text-sm text-slate-500 truncate">{[user.job_title, user.email].filter(Boolean).join(" · ")}</div>
        {user.platform_admin
          ? <span className="inline-block mt-1 text-xs font-bold px-2 py-0.5 rounded-full bg-[#0F172A] text-white" data-testid="profile-platform-badge">Platform Super Admin</span>
          : <span className="inline-block mt-1 text-xs font-semibold text-slate-600" data-testid="profile-company-badge">{user.company?.name} · {roleLabel(t, user.role)}</span>}
      </div>
    </div>
  );
}

export default function Profile() {
  const { t } = useLang();
  const { user, setUser } = useAuth();
  const [params, setParams] = useSearchParams();
  const tab = ["profile", "security", "company"].includes(params.get("tab")) ? params.get("tab") : "profile";
  useEffect(() => { api.get("/me/profile").then((r) => setUser(r.data)).catch(() => {}); }, [setUser]);
  const tabs = [["profile", t("My Profile", "Mi perfil")], ["security", t("Security", "Seguridad")], ["company", t("My Company", "Mi empresa")]];
  return (
    <>
      <PageHeader title={t("My Profile", "Mi perfil")} />
      <Header user={user} t={t} />
      <Tabs value={tab} onValueChange={(v) => setParams(v === "profile" ? {} : { tab: v })}>
        <TabsList className="w-full h-auto flex-wrap justify-start bg-slate-100 p-1 rounded-xl mb-4">
          {tabs.map(([k, l]) => <TabsTrigger key={k} value={k} className="min-h-[40px] px-4 rounded-lg font-semibold" data-testid={`profile-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="profile" className="grid lg:grid-cols-2 gap-4 items-start">
          <div className="grid gap-4"><PhotoBox /><EmailForm /></div>
          <PersonalForm />
        </TabsContent>
        <TabsContent value="security"><ProfileSecurity /></TabsContent>
        <TabsContent value="company"><MyCompany /></TabsContent>
      </Tabs>
    </>
  );
}
